import React, { useState } from "react";
import Layout from "../components/Layout/Layout";
import "./css/Terms.css";
import HeroSvg from "../components/Layout/HeroSvg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  ChevronLeftSvg,
  ListSvg,
} from "../components/AllSvgModulesExport/LoginSvg";
import { setActiveButton } from "../redux/features/footerMenuSlice";

const TermsAndConditions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sideMenu, setSideMenu] = useState(false);

  const onClose = () => {
    dispatch(setActiveButton("home"));
    navigate("/");
    localStorage.setItem("activeButton", "home");
  };

  return (
    <Layout>
      {/* DESKTOP  */}
      {/* DESKTOP  */}
      {/* DESKTOP  */}
      <div className="d-none d-lg-block">
        <div className="bg-heading">
          <h4>
            <b>Terms & Conditions</b>
          </h4>
        </div>
        <div className="terms-container">
          <p>
            Please read the following terms and conditions carefully before
            using our website and services:
          </p>

          <h5 className="">Acceptance of Terms:</h5>
          <p>
            - By accessing or using our website and services, you agree to
            comply with and be bound by these terms and conditions.
          </p>

          <h5 className="">User Eligibility:</h5>
          <p>
            - Users must be at least 13 years old to use our services. By using
            our services, you confirm that you meet this age requirement.
          </p>

          <h5 className="">Account Information:</h5>
          <p>
            - Users are responsible for maintaining the confidentiality of their
            account information, including login credentials. Any activity
            conducted under your account is your responsibility.
          </p>

          <h5 className="">In-Game Purchases:</h5>
          <p>
            - In-game purchases are subject to our refund policy. Users are
            solely responsible for all transactions made through their accounts.
          </p>

          <h5 className="">Emails We Send:</h5>
          <p>
            - We send service emails about your account and orders, such as
            OTPs, order confirmations and delivery updates. These are part of
            using Coinsup.
          </p>
          <p>
            - We send offers and promotional emails only if you choose to
            receive them, at signup, at checkout or in your Account settings.
            You can stop them anytime using the unsubscribe link in any email or
            the switch in My Account.
          </p>

          <h5 className="">Intellectual Property:</h5>
          <p>
            - All content on our website, including but not limited to text,
            graphics, logos, and images, is the property of Coinsup and is
            protected by intellectual property laws.
          </p>

          <h5 className="">Prohibited Activities:</h5>
          <p>
            - Users must not engage in any unlawful or prohibited activities,
            including but not limited to hacking, data mining, or any actions
            that could disrupt the integrity of our services.
          </p>

          <h5 className="">Third-Party Links:</h5>
          <p>
            - Our website may contain links to third-party websites. We are not
            responsible for the content or practices of these websites and
            encourage users to review their terms and conditions.
          </p>

          <h5 className="">Disclaimer of Warranties:</h5>
          <p>
            - Our services are provided "as is" without any warranty. We do not
            guarantee the accuracy, completeness, or reliability of our
            services.
          </p>

          <h5 className="">Limitation of Liability:</h5>
          <p>
            - Coinsup and its affiliates are not liable for any direct,
            indirect, incidental, or consequential damages resulting from the
            use of our services.
          </p>

          <h5 className="">Modification of Terms:</h5>
          <p>
            - We reserve the right to modify these terms and conditions at any
            time. Users will be notified of significant changes.
          </p>

          <h5 className="">Governing Law:</h5>
          <p>
            - These terms and conditions are governed by the laws of
            Jurisdiction. Any disputes shall be resolved in the courts of
            Jurisdiction.
          </p>

          <h5 className="">Contact Information:</h5>
          <p>
            - For inquiries related to these terms and conditions, please
            contact us at{" "}
            <span>
              <b>coinssups@gmail.com</b>
            </span>
            .
          </p>

          <p>
            <i>
              By using our website and services, you agree to abide by these
              terms and conditions. If you do not agree with any part of these
              terms, please refrain from using our services.
            </i>
          </p>
        </div>
      </div>

      {/* MOBILE  */}
      {/* MOBILE  */}
      {/* MOBILE  */}
      <div className={`account-modal-container d-lg-none d-md-none `}>
        <HeroSvg />
        <div className="account-modal-container-content">
          <div className="top-left-content">
            <div className="box-1 center" onClick={onClose}>
              <ChevronLeftSvg />
            </div>
            <h2 className="mb-0">Terms & conditions</h2>
          </div>
          <div
            className="top-right-content box-2 center"
            onClick={() => setSideMenu(!sideMenu)}
          >
            <ListSvg />
          </div>
        </div>
        <div className="terms-mobile-container">
          <p>
            Please read the following terms and conditions carefully before
            using our website and services:
          </p>

          <h5 className="">Acceptance of Terms:</h5>
          <p>
            - By accessing or using our website and services, you agree to
            comply with and be bound by these terms and conditions.
          </p>

          <h5 className="">User Eligibility:</h5>
          <p>
            - Users must be at least 13 years old to use our services. By using
            our services, you confirm that you meet this age requirement.
          </p>

          <h5 className="">Account Information:</h5>
          <p>
            - Users are responsible for maintaining the confidentiality of their
            account information, including login credentials. Any activity
            conducted under your account is your responsibility.
          </p>

          <h5 className="">In-Game Purchases:</h5>
          <p>
            - In-game purchases are subject to our refund policy. Users are
            solely responsible for all transactions made through their accounts.
          </p>

          <h5 className="">Emails We Send:</h5>
          <p>
            - We send service emails about your account and orders, such as
            OTPs, order confirmations and delivery updates. These are part of
            using Coinsup.
          </p>
          <p>
            - We send offers and promotional emails only if you choose to
            receive them, at signup, at checkout or in your Account settings.
            You can stop them anytime using the unsubscribe link in any email or
            the switch in My Account.
          </p>

          <h5 className="">Intellectual Property:</h5>
          <p>
            - All content on our website, including but not limited to text,
            graphics, logos, and images, is the property of Coinsup and is
            protected by intellectual property laws.
          </p>

          <h5 className="">Prohibited Activities:</h5>
          <p>
            - Users must not engage in any unlawful or prohibited activities,
            including but not limited to hacking, data mining, or any actions
            that could disrupt the integrity of our services.
          </p>

          <h5 className="">Third-Party Links:</h5>
          <p>
            - Our website may contain links to third-party websites. We are not
            responsible for the content or practices of these websites and
            encourage users to review their terms and conditions.
          </p>

          <h5 className="">Disclaimer of Warranties:</h5>
          <p>
            - Our services are provided "as is" without any warranty. We do not
            guarantee the accuracy, completeness, or reliability of our
            services.
          </p>

          <h5 className="">Limitation of Liability:</h5>
          <p>
            - Coinsup and its affiliates are not liable for any direct,
            indirect, incidental, or consequential damages resulting from the
            use of our services.
          </p>

          <h5 className="">Modification of Terms:</h5>
          <p>
            - We reserve the right to modify these terms and conditions at any
            time. Users will be notified of significant changes.
          </p>

          <h5 className="">Governing Law:</h5>
          <p>
            - These terms and conditions are governed by the laws of
            Jurisdiction. Any disputes shall be resolved in the courts of
            Jurisdiction.
          </p>

          <h5 className="">Contact Information:</h5>
          <p>
            - For inquiries related to these terms and conditions, please
            contact us at{" "}
            <span>
              <b>coinssups@gmail.com</b>
            </span>
            .
          </p>

          <p>
            <i>
              By using our website and services, you agree to abide by these
              terms and conditions. If you do not agree with any part of these
              terms, please refrain from using our services.
            </i>
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default TermsAndConditions;
